import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {DocumentationModel} from '@/sdk';
import {DocumentationApi} from '@/sdk/api-services';
import {Component, Prop} from 'vue-property-decorator';
import PreviewDocumentDialogComponent from '../preview-document-dialog/preview-document-dialog.component.vue';
import ModelUploaderDocumentComponent from './model-document-uploader-dialog/model-document-uploader-dialog.component';

@Component({
    components: {
        ModelUploaderDocumentComponent,
        PreviewDocumentDialogComponent,
    },
})
export default class T3DModelDocumentsComponent extends VueWrapper {
    public $refs!: {
        modelUploaderDocumentComponentRef: ModelUploaderDocumentComponent;
        preview3DModelDocumentDialog: PreviewDocumentDialogComponent;
    };

    @Prop({type: String, required: true})
    public readonly locationId!: string;

    documents: DocumentationModel[] = [];

    public documentationApi: DocumentationApi = new DocumentationApi();

    public mounted(): void {
        this.loadDocuments();
    }

    loadDocuments(): void {
        this.documentationApi
            .get3DModelDocuments(this.locationId)
            .then((response: DocumentationModel[]) => {
                this.documents = [...response];
            })
            .catch(error => {
                console.error('Error loading documents:', error);
            });
    }

    fileUploaded(event: {status: string}): void {
        if (event.status === 'success') {
            this.loadDocuments();
        }
    }

    addDocument(): void {
        this.$refs.modelUploaderDocumentComponentRef?.open();
    }

    preview3DModel(document: DocumentationModel): void {
        if (!document.fileType) {
            const extension = document.title?.split('.').pop();
            if (extension) {
                document.fileType = extension;
            } else {
                document.fileType = 'png';
            }
        }
        this.$refs.preview3DModelDocumentDialog.open(document);
    }

    download3DModel(d: DocumentationModel): void {
        this.LoaderSrv.showFullScreenLoader('Downloading report...');
        this.documentationApi
            .downloadDocument(d.id || '')
            .then((response: any) => {
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${d.title ?? 'documentation.png'}`);
                document.body.appendChild(link);
                link.click();

                //clean
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((e: any) => {
                console.error('Error downloading document:', e);
                this.AlertSrv.show('error', e?.error?.messagge ?? 'Failed to download document.');
            })
            .finally(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }

    deleteDocument(document: DocumentationModel): void {
        this.ConfirmSrv.open('Delete Document', 'Are you sure you want to delete this document?').then(yes => {
            if (yes) {
                this.documentationApi
                    .deleteDocAsync(document.id!)
                    .then(() => {
                        this.AlertSrv.show('success', 'Document deleted successfully');
                        this.loadDocuments();
                    })
                    .catch(error => {
                        console.error('Error deleting document:', error);
                        this.AlertSrv.show('error', 'Error deleting document');
                    });
            }
        });
    }
}
